import { PageHero } from "@/components/PageHero";
import React from "react";
import { Section } from "@/components/Section";
import { Link } from "react-router-dom";

const VALUES = ["Discipline","Respect","Performance","Opportunity","Community","Legacy"];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="About Ironveil Era" title="Who We Are" image="arena" position="center 20%" testId="about-hero">
        A modern Indian combat-sports organization — built for athletes, built to last.
      </PageHero>

      <Section title="Our Mission">
        <p className="text-[#c9c9c9] leading-relaxed max-w-3xl text-lg">
          Build structured opportunities and professional combat-sports experiences for athletes and communities across India — starting with MMA and Boxing.
        </p>
      </Section>

      <Section title="Our Vision">
        <p className="text-[#c9c9c9] leading-relaxed max-w-3xl text-lg">
          Build Ironveil Era into a leading combat-sports organization originating from India with long-term national and global ambitions.
        </p>
      </Section>

      <Section title="What We Stand For">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 max-w-4xl">
          {VALUES.map((v, i) => (
            <div key={v} className="card-ive p-4 sm:p-6 min-w-0">
              <div className="text-[#C8102E] type-meta">0{i+1}</div>
              <div className="font-display text-2xl lg:text-3xl mt-2 break-words">{v}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Our Sports">
        <div className="grid md:grid-cols-2 gap-6">
          {[{n:"MMA", d:"Mixed Martial Arts — amateur & professional divisions."},{n:"Boxing", d:"Modern boxing — amateur & professional pathways."}].map((s) => (
            <div key={s.n} className="card-ive p-8">
              <div className="type-stat text-[#C8102E]">{s.n}</div>
              <div className="divider-red mt-3 mb-4" />
              <p className="text-[#a0a0a0]">{s.d}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section title="The Era Ahead">
        <p className="text-[#c9c9c9] max-w-3xl text-lg leading-relaxed">
          Ironveil Era is being built with a long-term ambition: a serious combat-sports platform originating from India, developing athletes, competition and opportunity for the next generation.
        </p>
        <div className="mt-8 flex gap-4">
          <Link to="/register" className="btn-primary" data-testid="about-register-btn">Register as Athlete</Link>
          <Link to="/partners" className="btn-secondary" data-testid="about-partner-btn">Become a Partner</Link>
        </div>
      </Section>
    </div>
  );
}
